// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toolsTitle: 'HitPaw ऑनलाइन परम',
  freeTimesLimitTitle: 'मुफ्त खाते के लिए परीक्षण आज बाहर चला गया है।',
  fileSizeLimitTitle: 'सभी मुफ्त उपकरण और प्रीमियम सुविधाओं तक पहुंच',
  freeImgCutoutTimesLimitTitle:
    'बैकग्राउंड हटाने के लिए आज ट्रायल का अवसर समाप्त हो गया है, कृपया सभी प्रीमियम सुविधाओं तक पहुंचने के लिए प्रो में अपग्रेड करें',
  total: 'कुल',
  enterCode: 'कोड डालें',
  signUpToPurchaseBtn: 'ख़रीदने के लिए साइन अप करें',
  goPurchseBtn: 'ख़रीदारी पर जाएं',
  saveTips: '{{num}}% तक बचाएं',
  discount: 'छूट',
  priceWeek: '$9.99',
  priceMonth: '$7.49',
  priceYear: '$3.75',
  billedMonth: '$29.99 मासिक बिल',
  billedYear: '$179.99 वार्षिक बिल',
  monthly: 'मासिक',
  yearly: 'वार्षिक',
  weekly: 'साप्ताहिक',
  week: 'सप्ताह',
  AlreadySubscribe: 'पहले से सदस्यता ले रखी?',
  vipTips1: 'कोई फ़ाइल आकार सीमा नहीं',
  vipTips2: 'सीमा के बिना फ़ाइल मात्रा की प्रक्रिया',
  vipTips3: 'सीमा के बिना छवि पृष्ठभूमि बदलें',
  vipTips4: 'सभी मुफ्त उपकरण और प्रीमियम सुविधाओं तक पहुंच',
  purchaseTips: 'स्वचालित रूप से नवीनीकृत करें और किसी भी समय रद्द करें।',
  tips: 'उपाय:',
  promoCodeInvalidTips: 'आपका प्रोमो कोड अमान्य है',
  //2022.09.28 xxy
  freeImgBgChangerTimesLimitTitle:
    'Today’s trial oppotunity for changing background has been run out, please upgrade to Pro to access all premium features',
  vipBgChangerTips: 'Change image backgrounds without limits',
};
